import {BaseService} from './BaseService';
export default class AuthService extends BaseService {
    // Initializing important variables
    constructor(domain) {
        super(domain)
        this.login = this.login.bind(this)
    }

    login(email, password) {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/users/login`, {
            method: 'POST',
            body: JSON.stringify({
              "user": {
                "email": email,
                "password": password
              }
            })
        }).then(res => {
            this.setToken(res.user.token) // Setting the token in localStorage
            return Promise.resolve(res);
        })
    }


    logout() {
        // Clear user token and profile data from localStorage
        localStorage.removeItem('id_token');
    }

}



// WEBPACK FOOTER //
// ./src/services/AuthService.js